/**
 * Resolves a file image path from the API to a full, usable URL.
 *
 * The API returns relative paths like `/TenantAccessAPI/uploads/ktp_xxx.jpg`.
 * In XAMPP local, the app is served under /tenantaccess, so images are
 * accessible at /uploads/... after stripping the /TenantAccessAPI prefix.
 *
 * Paths that are already absolute (http/https) or data-URIs are returned as-is.
 * Empty / null values return an empty string.
 */
const IMAGE_BASE_PATH = "";

export function resolveImageUrl(filePath: string | null | undefined): string {
  if (!filePath) return "";

  // Already an absolute URL (http/https) or data URI — use as-is
  if (
    filePath.startsWith("data:") ||
    filePath.startsWith("http://") ||
    filePath.startsWith("https://")
  ) {
    return filePath;
  }

  // Strip /TenantAccessAPI prefix if present
  let cleanPath = filePath.replace(/^\/TenantAccessAPI/i, "");

  // Remove leading slashes
  cleanPath = cleanPath.replace(/^\/+/, "");

  return `/${cleanPath}`;
}

